const T_PREFIX = "home";

export const bannerTrns = {
  title: `${T_PREFIX}.banner.title`,
  description: `${T_PREFIX}.banner.description`,
  paragraphFirst: `${T_PREFIX}.banner.paragraph-first`,
  paragraphSecond: `${T_PREFIX}.banner.paragraph-second`,
  paragraphThird: `${T_PREFIX}.banner.paragraph-third`,
  paragraphFourth: `${T_PREFIX}.banner.paragraph-fourth`,
};

export const trandingClonesTrns = {
  title: `${T_PREFIX}.tranding-clones.title`,
};

export const unlockOpportunitiesTrns = {
  title: `${T_PREFIX}.unlock-opportunities.title`,
  description: `${T_PREFIX}.unlock-opportunities.description`,
  learnMoreButton: `${T_PREFIX}.unlock-opportunities.learn-more-btn`,
};

export const howToBuyTrns = {
  title: `${T_PREFIX}.how-to-buy.title`,
  description: `${T_PREFIX}.how-to-buy.description`,
  infoLinkLabel: `${T_PREFIX}.how-to-buy.info-link-label`,
  discussLinkLabel: `${T_PREFIX}.how-to-buy.discuss-link-label`,
  finaliseLinkLabel: `${T_PREFIX}.how-to-buy.finalise-link-label`,
};
